import { Badge } from '@reflex/ui/components/ui/badge';

export function ConstraintBadge({ constraint }: { constraint: string }) {
  const isPK = /PRIMARY\s+KEY/i.test(constraint);
  const isNotNull = /NOT\s+NULL/i.test(constraint);
  const isUnique = /UNIQUE/i.test(constraint);
  const defaultMatch = constraint.match(/DEFAULT\s+(.+)/i);

  return (
    <span className="flex flex-wrap gap-1">
      {isPK && (
        <Badge variant="default" className="px-1.5 py-0 text-3xs font-medium">
          PK
        </Badge>
      )}
      {isNotNull && !isPK && (
        <Badge variant="secondary" className="px-1.5 py-0 text-3xs font-normal">
          NOT NULL
        </Badge>
      )}
      {isUnique && (
        <Badge variant="secondary" className="px-1.5 py-0 text-3xs font-normal">
          UNIQUE
        </Badge>
      )}
      {defaultMatch && (
        <Badge
          variant="outline"
          className="px-1.5 py-0 font-mono text-3xs font-normal text-muted-foreground"
        >
          = {defaultMatch[1]}
        </Badge>
      )}
    </span>
  );
}
